import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import PageStructure from 'flarum/forum/components/PageStructure';
import classList from 'flarum/common/utils/classList';
import PageHero from './PageHero';
export default class PagePage extends Page {
  oninit(vnode) {
    super.oninit(vnode);

    /**
     * The page that is being viewed.
     *
     * @type {fof/pages/models/Page}
     */
    this.page = null;
    this.loadPage();
    this.bodyClass = 'App--page';
  }
  view() {
    const page = this.page;
    return m("div", {
      className: classList('Pages', page?.isHtml() && 'Pages--isHtml'),
      "data-id": page?.id(),
      "data-slug": page?.slug()
    }, m(PageStructure, {
      className: "PagePage",
      hero: () => this.hero(),
      loading: !page
    }, page && m("div", {
      className: "Pages-container"
    }, m("div", {
      className: "Post-body"
    }, this.content()))));
  }

  /**
   * Initialize page.
   *
   * @param {fof/pages/models/Page} page
   * @protected
   */
  show(page) {
    this.page = page;
    app.history.push('page', page.title());
    app.setTitle(page.title());
    m.redraw();
  }

  /**
   * Get the hero of current page.
   */
  hero() {
    return PageHero.component({
      page: this.page
    });
  }

  /**
   * Get the content of page.
   */
  content() {
    return m.trust(this.page.contentHtml());
  }

  /**
   * Get current page id from route.
   *
   * @return string
   */
  id() {
    const id = m.route.param('id').split('-')[0];
    if (!isNaN(parseInt(id))) {
      return id;
    } else {
      return m.route.param('id');
    }
  }

  /**
   * Load page from the store, or make a request
   * if we don't have it yet. Then initialize the page.
   */
  loadPage() {
    const id = this.id();
    const preloaded = app.preloadedApiDocument();
    const page = !Array.isArray(preloaded) && preloaded || app.store.getById('pages', id);
    if (page) {
      this.show(page);
    } else {
      Promise.all([app.store.find('pages', id).then(result => {
        this.show(result);
      }), m.redraw()]);
    }
  }
}
flarum.reg.add('fof-pages', 'forum/components/PagePage', PagePage);